module.exports = __webpack_public_path__ + "img/logo_side_round_w200.7feff438.png";